export default {
  // Dashboard
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.home': 'System Overview',
  'menu.dashboard.device-activation': 'Device Activation',
  'menu.dashboard.ecs': 'Service Images',
  'menu.home': 'Home',

  // Website Configuration
  'menu.website-config': 'Website Configuration',
  'menu.website-config.countdown': 'Countdown Configuration',
  'menu.website-config.home-banner': 'Home Banner Configuration',
  'menu.website-config.community-showcase': 'Community Showcase Configuration',
  'menu.website-config.github-deploy': 'Website Scheduled Publishing',

  // User Operations
  'menu.user-operations': 'User Operations',
  'menu.user-operations.points': 'Points Management',

  // Product Management
  'menu.product-management': 'Product Management',
  'menu.product-management.overview': 'Product Overview',
  'menu.product-management.sku': 'Product List',
  'menu.product-management.email-templates': 'Email Templates',
  'menu.product-management.firmware': 'Firmware Management',
  'menu.product-management.device': 'Device Management',
  'menu.overview': 'Overview',
  'menu.sku': 'Product List',
  'menu.email-templates': 'Email Templates',
  'menu.firmware': 'Firmware Management',
  'menu.device': 'Device Management',

  // Model Upload
  'menu.model-upload': 'Model Management',
  'menu.model-upload.list': 'All Models',
  'menu.model-upload.create': 'Upload Model',
  'menu.model-upload.category': 'Categories',
  'menu.model-upload.license': 'Licenses',

  // Model Management
  'menu.model-management': 'Model Management',
  'menu.model-management.official': 'Official Models',

  // Permission Management
  'menu.permission': 'Permission Management',
  'menu.permission.roles': 'Role Management',
  'menu.permission.permissions': 'Permission Management',
  'menu.permission.employees': 'Employee Management',
  'menu.roles': 'Role Management',
  'menu.permissions': 'Permission Management',
  'menu.employees': 'Employee Management',

  // Points Management
  'menu.points-management': 'Points Management',
  'menu.points-management.overview': 'Points Overview',
  'menu.points-management.transactions': 'Transaction Records',
  'menu.points-management.users': 'User Points Management',
  'menu.points-management.rules': 'Points Rules Management',

  // Sales Management
  'menu.sales-management': 'Sales Management',
  'menu.sales-management.ks-orders': 'KS Orders Management',
  'menu.ks-orders': 'KS Orders Management',

  // Monitoring
  'menu.monitoring': 'Monitoring',
  'menu.monitoring.domestic': 'Domestic',
  'menu.monitoring.overseas': 'Overseas',

  // User Operations
  'menu.points': 'Points Management',

  // Account
  'menu.account': 'Account',
  'menu.account.logout': 'Logout',

  // Common
  'menu.welcome': 'Welcome',
  'menu.login': 'Login',
  'menu.countdown': 'Countdown Configuration',

  // Exception Pages
  'menu.exception': 'Exception',
  'menu.exception.403': '403 Forbidden',
  'menu.exception.404': '404 Not Found',
  'menu.exception.500': '500 Server Error',
};
